import { get } from 'lodash';
import { connect } from 'react-redux';
import {
    DOCTOR_CARD_ROOT_KEY,
    PATIENT_INSURANCE_TYPES,
} from '../../../../constants';
import { DENTAL_INSURANCE_SPECIALTIES } from '../../../../constants';
import requirementsSelector from '../../AppointmentRequirementsSelector';
import { PRIMARY_CARE_CONFIRMATION_STATE_KEY } from '../../constants';
import {
    clickCheckbox,
    trackClickPrimaryCareWarning,
} from './ConfirmPrimaryCareActions';
import { ConfirmPrimaryCareView } from './ConfirmPrimaryCareView';

export function mapStateToProps(state) {
    const requirements = requirementsSelector(state);
    const shouldShowInvalidMessage =
        requirements[PRIMARY_CARE_CONFIRMATION_STATE_KEY].error;

    const specialtyId = get(
        state[DOCTOR_CARD_ROOT_KEY],
        'professional.specialtyId'
    );

    const insuranceType = DENTAL_INSURANCE_SPECIALTIES.has(specialtyId)
        ? PATIENT_INSURANCE_TYPES.DENTAL
        : PATIENT_INSURANCE_TYPES.HEALTH;

    const specialtyName =
        insuranceType === PATIENT_INSURANCE_TYPES.DENTAL
            ? 'primary dentist'
            : 'primary care doctor';

    const mustConfirmMessage = `You must confirm that this is your ${specialtyName}`;

    return {
        insuranceType,
        invalidMessage: shouldShowInvalidMessage && mustConfirmMessage,
        isChecked: requirements[PRIMARY_CARE_CONFIRMATION_STATE_KEY].value,
        specialtyName,
    };
}

export const mapDispatchToProps = {
    onCheck: clickCheckbox,
    trackClickPrimaryCareWarning,
};

export const ConfirmPrimaryCareConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmPrimaryCareView);
